<template>
    <section id="reviews" class="section_reviews">
        <h2 class="section--bar_title">REVIEWS</h2>
        <div class="grid-container">
            <section class="section_reviews--content grid-x grid-padding-x align-center">
                <reviews-Item v-if="screenSize" :item="displayTabLeft"> </reviews-Item>
                <reviews-Item v-if="screenSize" :item="displayTabRight"> </reviews-Item>
                <reviews-Item v-if="!screenSize" :item="reviewsData"> </reviews-Item>
                <p class="section_reviews--notice cell small-12 medium-10">※敬称略・順不同</p>
            </section>
        </div>
    </section>
</template>

<script>

import Vue from 'vue'
import axios from '@/services/axios'
import ReviewsItem from '@/components/ReviewsItem'

Vue.component('reviews-Item', ReviewsItem)

export default {
    name: 'reviews',
    data () {
        return {
            reviewsData: []
        }
    },

    created: function () {
        this.fetchData()
    },

    methods: {
        fetchData: function () {
            axios.get('comments?filter[posts_per_page]=100&filter[orderby]=menu_order&order=asc')
                .then(response => {
                    let allData = response.data
                    for (let data of allData) {
                        this.reviewsData.push(data.acf)
                    }
                })
        }
    },

    computed: {
        displayTabRight: function () {
            let returnData = []
            for (let index = 1; index <= this.reviewsData.length; index++) {
                if (index % 2 === 0) {
                    returnData.push(this.reviewsData[index - 1])
                }
            }
            return returnData
            // return this.reviewsData.slice((this.reviewsData.length / 2) + 1)
        },
        displayTabLeft: function () {
            let returnData = []
            for (let index = 1; index <= this.reviewsData.length; index++) {
                if (index % 2 !== 0) {
                    returnData.push(this.reviewsData[index - 1])
                }
            }
            return returnData
            // return this.reviewsData.slice(0, (this.reviewsData.length / 2) + 1)
        },
        screenSize: function () {
            return window.matchMedia('(min-width: 640px)').matches
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Reviews.vue